import type Alpine from "alpinejs";

export function registerNav(A: typeof Alpine) {
  A.data("momaNav", () => ({
    scrolled: false,
    drawerOpen: false,

    onScroll() {
      this.scrolled = window.scrollY > 80;
    },

    openDrawer() {
      const dlg = document.getElementById(
        "moma-drawer",
      ) as HTMLDialogElement | null;
      if (!dlg) return;
      this.drawerOpen = true;
      if (typeof dlg.showModal === "function") {
        dlg.showModal();
      } else {
        dlg.setAttribute("open", "");
      }
      document.documentElement.style.overflow = "hidden";
    },

    closeDrawer() {
      const dlg = document.getElementById(
        "moma-drawer",
      ) as HTMLDialogElement | null;
      if (!dlg) return;
      this.drawerOpen = false;
      if (typeof dlg.close === "function" && dlg.open) {
        dlg.close();
      } else {
        dlg.removeAttribute("open");
      }
      document.documentElement.style.overflow = "";
    },
  }));
}
